/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

const EditIcon = () => <FontAwesomeIcon icon={faPen} />;

export default EditIcon;
